import { createSelector } from '@reduxjs/toolkit';
import { SelectItem } from 'vet-bones/utils/select';

import { replaceableModelItemsSelector } from 'src/selectors/replaceableModelItems';

export type DataModelSelectItem = SelectItem & {
  namedGraphIri: string;
};

/**
 * Get "Data Models", which are defined as a pair of
 * {reasoning schema model name} to {named graph iri},
 * where there is only 1 named graph iri assigned to this model name.
 */
export const dataModelItemsSelector = (databaseId: string) =>
  createSelector(
    replaceableModelItemsSelector(databaseId),
    (replaceableModelItems): DataModelSelectItem[] =>
      replaceableModelItems
        .filter(
          (item) =>
            // only allow models that reference a single named graph
            item.namedGraphIris.length === 1
        )
        .map((item) => ({
          ...item,
          namedGraphIri: item.namedGraphIris[0],
        }))
  );
